import { useEffect, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import {
  addDocument,
  getAllData,
  updateDocument,
} from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const OfflineContact = ({ data = [], coll = [] }) => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleAssign = async (
    contact,
    selectedEmpName,
    selectedEmpEmail,
    selectedEmpid
  ) => {
    if (!contact.id) {
      alert("Missing document ID");
      return;
    }

    const assignedInfo = {
      selectedEmpName,
      selectedEmpEmail,
      selectedEmpid,
    };

    try {
      await updateDocument("contactMessages", contact.id, {
        assignedTo: assignedInfo,
      });

      setContacts((prev) =>
        prev.map((c) =>
          c.id === contact.id ? { ...c, assignedTo: assignedInfo } : c
        )
      );

      alert(`Assigned to ${selectedEmpName}`);
    } catch (error) {
      console.error("Error assigning employee:", error);
      alert("Assignment failed.");
    }
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        await getAllData("contactMessages", (allData) => {
          const offlineOnly = allData.filter(
            (item) => item.source === "offline-form"
          );
          setContacts(offlineOnly);
        });
      } catch (err) {
        console.error("Error loading employees", err);
      }
    };
    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("contactMessages", setContacts);
      } catch (error) {
        console.error("Error fetching data", error);
        alert("Failed to load contact messages");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        await getAllData("financeUserPortal", (empData) => {
          setEmployees(empData);
        });
      } catch (error) {
        console.error("Error fetching employees:", error);
        alert("Failed to load employees.");
      }
    };

    fetchEmployees();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const validateForm = () => {
    // Check for empty fields
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.message.trim()
    ) {
      alert("All fields are required");
      return false;
    }

    // Validate email format
    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      alert("Please enter a valid email address");
      return false;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      alert("Please enter a valid 10-digit phone number");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setSubmitting(true);
      const id = await addDocument("contactMessages", {
        ...formData,
        source: "offline-form",
      });
      setContacts((prev) => [...prev, { ...formData, id }]);
      setFormData({ name: "", email: "", phone: "", message: "" });
      setShowModal(false);
      alert("Contact message added successfully");
    } catch (error) {
      console.error("Error adding document:", error);
      alert("Failed to add contact message");
    } finally {
      setSubmitting(false);
    }
  };

  const handleDownloadExcel = () => {
    if (!contacts.length) {
      alert("No data to export.");
      return;
    }
    const filtereddata = contacts.map((item , index ) => ({
      "sr.no": index + 1,
      Name: item.name || "NA",
      Email: item.email || "NA",
      Phone: item.phone || "NA",
      Message: item.message || "NA",
      Action: item.assignedTo?.selectedEmpName || "NA",
      Source: item.source === "offline-form" ? "Ofline-Form" : "Online-Form"
    }))

    const worksheet = XLSX.utils.json_to_sheet(filtereddata);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OfflineContacts");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "OfflineContacts.xlsx");
  };

  const handleShow = (item) => {
    setSelectedItem(item);
    setSelectedEmployee(
      item.assignedTo || {
        selectedEmpName: "",
        selectedEmpEmail: "",
        selectedEmpid: "",
      }
    );
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedItem(null);
    setSelectedEmployee("");
  };

  const handleSave = () => {
    if (selectedItem) {
      handleAssign(
        selectedItem,
        selectedEmployee.selectedEmpName,
        selectedEmployee.selectedEmpEmail,
        selectedEmployee.selectedEmpid
      );
    }
    handleClose();
  };

  if (loading) return <LoadingCircular />;

  return (
    <>
      <div className="hide">
        <h1>Offline Contact</h1>
      </div>

      <Button className="mb-3" onClick={() => setShowModal(true)}>
        + Add New
      </Button>
      <Button
        variant="success"
        className="mb-3 ms-2"
        onClick={handleDownloadExcel}
      >
        ⬇️ Download Excel
      </Button>

      <div style={{ width: "100%" }}>
        <div className="table-responsive">
          <Table bordered>
            <thead>
              <tr>
                <th style={{ backgroundColor: "black", color: "white" }}>
                  Sr.n.
                </th>
                {["Name", "Email", "Phone", "Message", "Action"].map(
                  (item, index) => (
                    <th
                      style={{ backgroundColor: "black", color: "white" }}
                      key={index}
                    >
                      {item}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {contacts.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.name || "-"}</td>
                  <td>{item.email || "-"}</td>
                  <td>{item.phone || "-"}</td>
                  <td>{item.message || "-"}</td>
                  <td>
                    {item.assignedTo ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span>{item.assignedTo.selectedEmpName}</span>
                        <Button
                          variant="warning"
                          size="sm"
                          onClick={() => handleShow(item)}
                        >
                          Edit
                        </Button>
                      </div>
                    ) : (
                      <Button
                        variant="primary"
                        onClick={() => handleShow(item)}
                      >
                        Assign
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      <Modal show={showModal} onHide={() => !submitting && setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Contact Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter name"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter phone number"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter your message"
                rows={3}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            disabled={submitting}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Assign Employee</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Select
            value={selectedEmployee?.selectedEmpid || ""}
            onChange={(e) => {
              const emp = employees.find((emp) => emp.id === e.target.value);
              if (emp) {
                setSelectedEmployee({
                  selectedEmpName: emp.name,
                  selectedEmpEmail: emp.email,
                  selectedEmpid: emp.id,
                });
              }
            }}
          >
            <option value="" disabled>
              Select Employee
            </option>
            {employees.map((emp, i) => (
              <option key={i} value={emp.id}>
                {emp.name}
              </option>
            ))}
          </Form.Select>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleSave}>
            Assign
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OfflineContact;
